import { render, staticRenderFns } from "./CustomerPlans.vue?vue&type=template&id=a8d8e0dc"
import script from "./CustomerPlans.vue?vue&type=script&lang=js"
export * from "./CustomerPlans.vue?vue&type=script&lang=js"
import style0 from "./CustomerPlans.vue?vue&type=style&index=0&id=a8d8e0dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports